"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _buttonModule = _interopRequireDefault(require("./button.module.css"));

const _excluded = ["className", "variant", "gradient", "outline", "shadow", "disabled", "label", "href", "onClick", "type"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

const Button = props => {
  const {
    className,
    variant,
    gradient,
    outline,
    shadow,
    disabled,
    label,
    href,
    onClick,
    type
  } = props,
        rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  const linkProps = {
    href: href || undefined,
    target: '_blank',
    rel: 'noopener noreferrer'
  };

  const buttonProps = _objectSpread(_objectSpread({}, rest), {}, {
    className: (0, _clsx.default)(_buttonModule.default.button, className, 'primary' === variant && 'secondary' !== variant && _buttonModule.default.primary, 'secondary' === variant && _buttonModule.default.secondary, 'tertiary' === variant && _buttonModule.default.tertiary, 'cancel' === variant && _buttonModule.default.cancel, gradient && _buttonModule.default.gradient, outline && _buttonModule.default.outline, shadow && _buttonModule.default.shadow, disabled && _buttonModule.default.disabled),
    disabled,
    onClick: onClick && onClick
  });

  const newButton = /*#__PURE__*/_react.default.createElement(href ? 'a' : 'button', _objectSpread(_objectSpread({}, buttonProps), linkProps), label);

  return newButton;
};

Button.defaultProps = {
  label: 'Button label',
  variant: 'primary',
  className: '',
  gradient: false,
  outline: false,
  shadow: true,
  disabled: false,
  href: false,
  onClick: () => {}
};
Button.propTypes = {
  label: _propTypes.default.string,
  variant: _propTypes.default.string,
  className: _propTypes.default.string,
  gradient: _propTypes.default.bool,
  outline: _propTypes.default.bool,
  shadow: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  href: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
};
var _default = Button;
exports.default = _default;